import Chart from "../Graphs/Category2/ChartSample";
import DocumentFrequency from "../Graphs/Category1/DocumentFrequency";
import ApprovalDocumentTimeAverage from "../Graphs/Category1/ApprovalDocumentTimeAverage";
import ApprovalTimeAverage from "../Graphs/Category1/ApprovalTimeAverage";
import DocumentRejectionRate from "../Graphs/Category1/DocumentRejectionRate";
import UserRejectionRate from "../Graphs/Category1/UserRejectionRate";
import DeviceFrequency from "../Graphs/Category1/DeviceFrequency";
import ApplyDocumentNumber from "../Graphs/Category1/ApplyDocumentNumber";
//描画可能なグラフ一覧
//graphTypeとcomponentは必須
//graphGetterにはdomein/[各種グラフゲッター]を記載、グラフのソート等に使用
const GraphList = [
    {
        defaultWidth: 2,
        defaultHeight: 2,
        graphType: "documentFrequency",
        graphTitle: "書類の利用状況",
        graphDescription: "書類の利用状況のグラフです。",
        component: DocumentFrequency,
    },
    {
        defaultWidth: 3,
        defaultHeight: 3,
        graphType: "approvalDocumentTimeAverage",
        graphTitle: "書類別の平均承認完了時間",
        graphDescription: "各書類の承認完了までにかかっている平均時間のグラフです。",
        component: ApprovalDocumentTimeAverage,
        graphGetter: "GET_APPROVAL_DOC_TIME_AVERAGE_LIST"
    },
    {
        defaultWidth: 3,
        defaultHeight: 3,
        graphType: "approvalTimeAverage",
        graphTitle: "社員別の平均承認時間",
        graphDescription: "各社員が承認するまでにかかっている平均時間のグラフです。",
        component: ApprovalTimeAverage,
    },
    {
        defaultWidth: 3,
        defaultHeight: 3,
        graphType: "documentRejectionRate",
        graphTitle: "書類別の却下率",
        graphDescription: "各書類の却下率のグラフです。",
        component: DocumentRejectionRate,
        graphGetter: "GET_DOCUMENT_REJECTION_RATE_LIST"
    },
    {
        defaultWidth: 3,
        defaultHeight: 3,
        graphType: "userRejectionRate",
        graphTitle: "社員別申請データの却下率",
        graphDescription: "各社員の申請データ却下率のグラフです。",
        component: UserRejectionRate,
    },
    {
        defaultWidth: 2,
        defaultHeight: 2,
        graphType: "deviceFrequency",
        graphTitle: "デバイスの利用状況",
        graphDescription: "デバイスの利用状況のグラフです。",
        component: DeviceFrequency,
    },
    {
        defaultWidth: 2,
        defaultHeight: 2,
        graphType: "applyDocumentNumber",
        graphTitle: "申請データの総数",
        graphDescription: "申請データの総数です。",
        component: ApplyDocumentNumber,
    },
    {
        defaultWidth: 2,
        defaultHeight: 2,
        graphType: "",
        graphTitle: "サンプルのグラフタイトル",
        graphDescription: "サンプルのグラフ説明",
        component: Chart,
    },
];

export default GraphList